<template>
  <div class="page">
    <Header>
      <template #title>
        <span>リトル・ママオンラインフェスタ</span>
        抽選会プレゼント一覧
      </template>
    </Header>
    <div class="presents-wrapper">
      <div class="inner">
        <Heading>
          <template #heading>
            豪華キーワード3つで当たる<br>
            豪華商品がこちら
          </template>
        </Heading>
        <div class="presents">
          <Present
            v-for="(present, index) in presents" :key="index"
            :present="present"
          />
        </div>
      </div>
    </div>
    <div class="inner">
      <Howto />
    </div>
    <Floating>
      <template #content>
        <div v-if="month === '202006'">
          <Button06 :month="month"/>
        </div>
        <div v-if="month === '202007'">
          <Button07 :month="month"/>
        </div>
        <div v-if="month === '202008'">
          <Button08 :month="month"/>
        </div>
      </template>
    </Floating>
  </div>
</template>

<script>
import Header from '@/components/organisms/202008/Header.vue'
import Heading from '@/components/atoms/Heading.vue'
import Present from '@/components/molecules/Present.vue'
import Howto from '@/components/organisms/Howto.vue'
import Floating from '@/components/molecules/Floating.vue'
import Button06 from '@/components/atoms/202006/Button.vue'
import Button07 from '@/components/atoms/202007/Button.vue'
import Button08 from '@/components/atoms/202008/Button.vue'

export default {
  name: 'present',
  components: {
    Header,
    Heading,
    Present,
    Howto,
    Floating,
    Button06,
    Button07,
    Button08
  },
  data: () => ({
    presents: [
      {
        thumbnail: '/img/present08/01.png',
        name: 'Dyson Hot+Cool ファンヒーター',
        num: '1名',
        description: '夏はスムーズで涼しい風を届け、冬は部屋をすばやく暖かくしてくれます。遠くまでパワフルな風を届けるフォーカスモードと、周囲の風を巻き込み広範囲に風を届けるワイドモードを搭載。高速回転する羽根がなく、どなたでも安心してご利用いただけます。',
        company: 'ダイソン株式会社',
        url: 'https://www.dyson.co.jp/air-treatment/heaters/am09/am09-white-nickel.aspx'
      },
      {
        thumbnail: '/img/present08/02.png',
        name: 'シロカ 全自動ホームベーカリー SB-111',
        num: '1名',
        description: '7つのオートパンメニューに加え、アレンジ簡単なパン生地が作れるコースや、こね、発酵、焼きの工程を単独で行える独立メニューを搭載することで、毎日のパンづくりをこれ1台でお楽しみ頂けます。生地コースやフランスパン風コースなど17メニュー搭載！',
        company: 'シロカ株式会社',
        url: 'https://www.siroca.co.jp/'
      },
      {
        thumbnail: '/img/present08/03.png',
        name: 'DaG3　navy（ダッグスリー　ネイビー）',
        num: '1名',
        description: 'ウエストポーチがヒップシートに変化します。長財布や500mlのペットボトル，替えおむつ等収納できます。外出先での抱っこは勿論、おうちの中での寝かしつけ、授乳の補助等横抱きにも使えます。簡単なのでおじいちゃん、おばあちゃんにもお薦めです。',
        company: '株式会社ジャナ・ジャパン ブランド名　TeLasbaby',
        url: 'https://www.telasbaby.jp/'
      },
      {
        thumbnail: '/img/present08/04.png',
        name: 'オーガニックカットソー（WOMEN・Mサイズ）',
        num: '2名',
        description: 'いつも頑張るママに、デンマークオーガニックの上質な優しさと心地よさを。有害物質を一切含まない、とろみのある柔らかい生地＆北欧らしい深みのあるグレーで、上品に着こなすことができます。デンマークブランドDanefae（ダナフェ）の、世界で認められたオーガニックの肌触りをお楽しみください。※Sサイズをお送りしますが、通常Mサイズの方が着てちょうどいいサイズです。',
        company: 'デンマークのオーガニックコットン子供服 vippe',
        url: 'https://www.seesaw.ne.jp/'
      },
      {
        thumbnail: '/img/present08/05.png',
        name: '福岡なし（豊水2㎏箱）',
        num: '5名',
        description: '福岡は西日本の中でも有数のなし産地です。「福岡なし」は太陽の光をたくさん浴びて、今年もおいしく育っています。プレゼントの「豊水」は甘味の中に程よい酸味があり、味がしっかりしています。甘味・果汁たっぷりのおいしい「福岡なし」で暑さ厳しい夏を乗り越えましょう。',
        company: 'ＪＡ全農ふくれんなし部会',
        url: 'https://zennoh-fukuren.jp/consumer/fruit/nashi'
      },
      {
        thumbnail: '/img/present08/06.png',
        name: 'ドーリーウインク　イージーラッシュ',
        num: '10名',
        description: 'さっと接着剤をつけたら、たった10秒でマツエク仕上げ。アイメイクの常識を変える 新・部分用つけまつげ「EASY LASH」。その日の気分に合わせて選べて、マスカラいらずで垢抜けアイメイクが簡単に完成します。メイクやファッションなどに合わせて、新しい毎日を楽しんでみて。',
        company: '株式会社コージー本舗',
        url: 'https://www.dollywink-jp.com/easylash/'
      }
    ]
  }),
  mounted () {
    document.title = '抽選会プレゼント一覧 - リトル・ママオンラインフェスタ'
  }
}
</script>

<style lang="sass" scoped>
.page
  padding: 60px 0 100px
.presents-wrapper
  background-color: $lightpink
  padding: 25px 0
  .presents
    .present
      margin-top: 25px
</style>
